import brightlineStorefront from '../assets/screenshots/brightline_electrical_storefront.png';
import serviceWizardLandscaping from '../assets/screenshots/service_wizard_landscaping_screenshot.png';
import serviceWizardResults from '../assets/screenshots/service_wizard_landscaping_results.png';

/** Screenshots for the public launch page preview strip. */
export const launchScreenshots = [
  {
    src: brightlineStorefront,
    alt: 'Example provider storefront on NKY Connect',
    caption:
      'Each business gets a storefront page where customers can view their services, prices, local reviews, and more.',
  },
  {
    src: serviceWizardLandscaping,
    alt: 'Service wizard — choosing a project type',
    caption:
      'Our service wizard flow will ask you questions about your service need and match you with providers who best fit.',
  },
  {
    src: serviceWizardResults,
    alt: 'Service wizard — matched providers',
    caption:
      'Users can reach out to matched businesses to inquire about getting quotes or scheduling service.',
  },
];
